import React, { useState } from 'react';
import { Button } from './ui/Button';
import { X, Send, CheckCircle, AlertCircle, Loader2 } from 'lucide-react';
export function CommunitySection() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    description: ''
  });
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    try {
      const response = await fetch('https://formsubmit.co/ajax/fgsukraine@gmail.com', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          ...formData,
          _subject: `Історія від ${formData.name}`,
          _captcha: 'false'
        })
      });
      if (response.ok) {
        setStatus('success');
        setFormData({
          name: '',
          email: '',
          phone: '',
          description: ''
        });
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };
  const closeModal = () => {
    setIsModalOpen(false);
    if (status === 'success') {
      setStatus('idle');
    }
  };
  return <>
      <section className="relative py-24 md:py-32 flex items-center justify-center overflow-hidden" data-id="element-41">
        {/* Background */}
        <div className="absolute inset-0 z-0" data-id="element-42">
          <img src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1600&h=600&fit=crop&q=80" alt="Спільнота людей" className="w-full h-full object-cover" data-id="element-43" />
          <div className="absolute inset-0 bg-[#0A5E5C]/90 mix-blend-multiply" data-id="element-44" />
        </div>

        {/* Content */}
        <div className="relative z-10 container mx-auto px-4 text-center max-w-3xl" data-id="element-45">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-white mb-6" data-id="element-46">
            Поділіться своєю історією, надихніть інших
          </h2>

          <p className="text-lg text-white/90 mb-10 leading-relaxed" data-id="element-47">
            Якщо Ви бажаєте поділитися власним досвідом подолання залежності для
            того, щоб надихнути інших, хто шукає вихід із складної ситуації, ми
            дуже це цінуємо і просимо заповнити форму. Ми зв'яжемося з Вами. Ви
            можете бути впевнені, що будь яка інформація про Вас і Ваш досвід
            залишиться конфіденційною і не буде розголошена без Вашої згоди.
          </p>

          <Button variant="outline" size="lg" className="border-[#D4A843] text-[#D4A843] hover:bg-[#D4A843] hover:text-white hover:border-[#D4A843]" onClick={() => setIsModalOpen(true)} data-id="element-48">
            Розповісти свою історію
          </Button>
        </div>
      </section>

      {/* Modal */}
      {isModalOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={closeModal} data-id="element-49">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-50" />

          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-51">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-52">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-53">
                Розповісти свою історію
              </h3>
              <button onClick={closeModal} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-54">
                <X className="w-5 h-5" data-id="element-55" />
              </button>
            </div>

            <div className="p-6" data-id="element-56">
              {status === 'success' ? <div className="text-center py-8" data-id="element-57">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5" data-id="element-58">
                    <CheckCircle className="w-8 h-8 text-green-600" data-id="element-59" />
                  </div>
                  <h4 className="text-xl font-serif font-bold text-[#0A5E5C] mb-3" data-id="element-60">
                    Дякуємо за вашу історію!
                  </h4>
                  <p className="text-gray-600 mb-6" data-id="element-61">
                    Ми отримали вашу інформацію і зв'яжемося з вами найближчим
                    часом.
                  </p>
                  <Button variant="outline" onClick={closeModal} data-id="element-62">
                    Закрити
                  </Button>
                </div> : <form onSubmit={handleSubmit} className="space-y-5" data-id="element-63">
                  <p className="text-gray-600 text-sm mb-2" data-id="element-64">
                    Заповніть форму нижче. Вся інформація залишиться
                    конфіденційною.
                  </p>

                  <div className="space-y-1.5" data-id="element-65">
                    <label htmlFor="story-name" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-66">
                      Ім'я та Прізвище
                    </label>
                    <input type="text" id="story-name" name="name" required value={formData.name} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="Ваше ім'я" data-id="element-67" />
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-68">
                    <div className="space-y-1.5" data-id="element-69">
                      <label htmlFor="story-email" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-70">
                        Email
                      </label>
                      <input type="email" id="story-email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="email@example.com" data-id="element-71" />
                    </div>

                    <div className="space-y-1.5" data-id="element-72">
                      <label htmlFor="story-phone" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-73">
                        Телефон
                      </label>
                      <input type="tel" id="story-phone" name="phone" required value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all" placeholder="+38 (0XX) XXX-XX-XX" data-id="element-74" />
                    </div>
                  </div>

                  <div className="space-y-1.5" data-id="element-75">
                    <label htmlFor="story-description" className="block text-sm font-medium text-[#0A5E5C]" data-id="element-76">
                      Ваша історія
                    </label>
                    <textarea id="story-description" name="description" rows={5} required value={formData.description} onChange={handleChange} className="w-full px-4 py-3 rounded-lg border border-gray-200 focus:border-[#0A5E5C] focus:ring-2 focus:ring-[#0A5E5C]/20 outline-none transition-all resize-none" placeholder="Розкажіть свою історію..." data-id="element-77"></textarea>
                  </div>

                  {status === 'error' && <div className="flex items-center gap-2 text-red-600 bg-red-50 p-3 rounded-lg border border-red-100" data-id="element-78">
                      <AlertCircle className="w-5 h-5 flex-shrink-0" data-id="element-79" />
                      <p className="text-sm" data-id="element-80">
                        Виникла помилка. Будь ласка, спробуйте ще раз.
                      </p>
                    </div>}

                  <Button type="submit" variant="secondary" size="lg" className="w-full flex items-center justify-center gap-2" disabled={status === 'submitting'} data-id="element-81">
                    {status === 'submitting' ? <>
                        <Loader2 className="w-5 h-5 animate-spin" data-id="element-82" />
                        Відправка...
                      </> : <>
                        <Send className="w-5 h-5" data-id="element-83" />
                        Надіслати історію
                      </>}
                  </Button>

                  <p className="text-xs text-center text-gray-500" data-id="element-84">
                    Натискаючи кнопку, ви погоджуєтесь на обробку персональних
                    даних
                  </p>
                </form>}
            </div>
          </div>
        </div>}
    </>;
}